import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CachedNamesClass;
function CachedNames() {
  if (CachedNamesClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CachedNames');
    CachedNamesClass = $;
  }
  return CachedNamesClass;
}
//region block: exports
export {
  CachedNames as CachedNames2minxlyafeo07,
};
//endregion

//# sourceMappingURL=CachedNames.mjs.map
